import { makeStyles } from "@material-ui/core";

export const SingleDieselCardCss = makeStyles(() => ({

    divAlignV1: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    divAlignV2: {
        display: 'flex',
        alignItems: 'center'
    },
    rightIcon: {
        color: '#456BDA'
    },
    helpCard: {
        borderRadius: '8px',
        backgroundColor: 'white',
        boxShadow: 'none !important',
        width: '290px',
        "&:hover": {
            cursor: 'pointer',
            backgroundColor: '#F8F8F8'
        }
    },
    noPadding: {
        padding: '16px 12px 16px 16px !important',
    },
    gridContainerV1: {
        marginTop: 15,
        paddingLeft: 8,
        paddingRight: 8,
        paddingBottom: 16
    },
    fitContent: {
        width: 'fit-content'
    },
    gridSubContainerV1: {
        marginRight: 8
    },
    mt8: {
        marginTop: '8px'
    },
    questionOuterDiv: {
        backgroundColor: '#a9ecd4',
        width: '32px',
        height: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        color: 'white',
        fontWeight: 600
    },
    questionInnerDiv: {
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        border: '2px solid white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '12px'
    },
    helperText: {
        fontWeight: 300,
        marginLeft: '16px'
    },
    cardContentV1: {
        padding: '24px !important'
    },
    historyText: {
        fontSize: '16px',
        color: '#0b1323',
        marginLeft: 12,
        fontWeight: 300
    },
    transactionHistoryCard: {
        boxShadow: 'none !important',
    },
    dieselCardRecharge: {
        padding: '6px 16px 6px 12px',
        borderRadius: '4px',
        backgroundColor: '#00885a',
        color: 'white',
        textTransform: 'none !important',
        marginTop: 8,
        boxShadow: 'none !important',
        "&:hover": {
            backgroundColor: '#00885a'
        }
    },
    fsV1: {
        fontSize: '26px !important'
    },
    divEmptyContainer: {
        textAlign: 'center',
        marginTop: 28
    },
    amountLoss: {
        color: '#FF3636',
        fontWeight: 'bold'
    },
    amountProfit: {
        color: '#00885a',
        fontWeight: 'bold'
    },
    viewMapButton: {
        border: '1px solid #0033cc',
        fontWeight: 'bold',
        textTransform: 'none',
        fontSize: 12,
        borderRadius: 4,
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 36,
        paddingRight: 36,
        color: '#0033cc'
    },
    rechargeButton: {
        backgroundColor: '#0033cc',
        color: 'white',
        fontWeight: 'bold',
        textTransform: 'none',
        fontSize: 12,
        borderRadius: 4,
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 27,
        paddingRight: 27,
        boxShadow: "none !important",
        '&:hover': {
            backgroundColor: '#0033cc'
        }
    },
    emptyText: {
        color: 'rgba(11, 19, 35, 0.75)',
        fontSize: '18px',
        marginTop: 32,
        fontWeight: 300
    },
    eventName: {
        color: 'grey',
        fontSize: 12,
        fontWeight: 300
    },
    fw500: {
        fontWeight: 500
    },
    paymentCard: {
        borderRadius: '8px !important',
        boxShadow: 'none !important'
    },
    titleV1: {
        fontSize: '12px',
        color: 'rgba(11, 19, 35, 0.75)',
        fontWeight: 300
    },
    textAlignLeft: {
        textAlign: 'left'
    },
    textAlignRight: {
        textAlign: "right"
    },
    detailsText: {
        fontSize: 16,
        color: '#0b1323',
        marginTop: 2
    },
    rechargeAgainButton: {
        borderRadius: '4px',
        border: 'solid 1px #03c',
        padding: '5px 20px 6px',
        textTransform: 'none !important',
        boxShadow: 'none !important',
        color: '#0033cc',
        fontSize: '12px'
    },
    divContainer: {
        width: '100%',
        textAlign: 'right',
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: 16
    },
    successDiv: {
        display: 'flex',
        padding: "12px 16px",
        alignItems: 'center',
        backgroundColor: "#00885a",
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8
    },
    pendingDiv: {
        display: 'flex',
        padding: "12px 16px",
        alignItems: 'center',
        backgroundColor: "#ffa462",
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8
    },
    successIcon: {
        marginRight: 16,
        color: "#fff"
    },
    pendingIcon: {
        marginRight: 16,
        color: "#fff"
    },
    imgV2: {
        width: 32,
        height: 32,
        marginRight: 16
    },
    headerTxt: {
        fontSize: 16,
        fontWeight: "normal",
        color: "#fff"
    },
    headerTxtError: {
        fontSize: 16,
        fontWeight: "normal",
        color: "#E61B1B"
    },
    divContent: {
        padding: '16px'
    },
    mt16: {
        marginTop: 16
    },
    failedDiv: {
        backgroundColor: '#f8cece',
        display: 'flex',
        padding: "12px 16px",
        alignItems: 'center',
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8
    },
    tableTitleIcon: {
        fontSize: 24
    },
    mt28: {
        marginTop: '28px !important'
    },
    fs12: {
        fontSize: '12px !important'
    }

}));
